define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../utils/dateUtils", "../../utils/stringUtils", "../../shared/dataLogs", "../../models/UserContext", "./cdrActions"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, dateUtils, stringUtils, DataLogs, UserContext, CdrActions) {
    "use strict";
    var CallDetailRecord = /** @class */ (function () {
        function CallDetailRecord() {
            this.filterByStartDate = ko.observable(dateUtils.firstDayOfMonth());
            this.filterByEndDate = ko.observable(dateUtils.lastDayOfMonth());
            this.filterByAny = ko.observable('');
            this.filterByProvider = ko.observable('');
            this.filterByCallType = ko.observable('');
            this.filterByCustomerName = ko.observable('');
            this.filterByCustomer = ko.observable('');
            this.filterTollFreeByStartDate = ko.observable(dateUtils.firstDayOfMonth());
            this.filterTollFreeByEndDate = ko.observable(dateUtils.lastDayOfMonth());
            this.filterTollFreeByAny = ko.observable('');
            this.filterTollFreeByCustomerName = ko.observable('');
            this.filterTollFreeByCustomer = ko.observable('');
            this.filterInternationalByStartDate = ko.observable(dateUtils.firstDayOfMonth());
            this.filterInternationalByEndDate = ko.observable(dateUtils.lastDayOfMonth());
            this.filterInternationalByAny = ko.observable('');
            this.filterInternationalByCustomerName = ko.observable('');
            this.filterInternationalByCustomer = ko.observable('');
            this.canExport = ko.observable(UserContext.hasAccess('Admin,CallDetailRecord.Export'));
        }
        CallDetailRecord.prototype.init = function () {
            var self = this;
            $("#page-title").text("Call Detail Records");
            self.cdrActions = new CdrActions();
            tools.ajaxGet({
                url: '/CallDetailRecord/GetDetailsListLookupData',
                success: function (data) {
                    if (data.Success) {
                        self.cdrLookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.initTollFreeGrid(self.cdrLookupLists.GridStructures.CdrTollFreeSummaryStructure);
                    self.initInternationalGrid(self.cdrLookupLists.GridStructures.CdrInternationalSummaryStructure);
                    self.initGrid(self.cdrLookupLists.GridStructures.CallDetailRecordStructure);
                    self.initImportRegisterGrid(self.cdrLookupLists.GridStructures.CdrImportRegisterStructure);
                    ko.applyBindings(self, document.getElementById('main-container'));
                    $('#contextLoader').hide();
                    $('#mainContext').show();
                }
            });
        };
        CallDetailRecord.prototype.initInternationalGrid = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            self.cdrInternationalTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/CallDetailRecord/GetCdrInternationalSummaryRecords",
                            type: "POST",
                            data: function () {
                                var data = {};
                                data.startDate = dateUtils.toIsoStringDate(self.filterInternationalByStartDate());
                                data.endDate = dateUtils.toIsoStringDate(self.filterInternationalByEndDate());
                                if (self.filterInternationalByCustomer()) {
                                    data.customerIds = self.filterInternationalByCustomer();
                                }
                                if (self.filterInternationalByAny()) {
                                    data.filterText = self.filterInternationalByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model
                    },
                    pageSize: 10,
                    aggregate: gridStructure.aggregate,
                    serverAggregates: true
                },
                gridOptions: {
                    toolbar: kendo.template($('#cdr-international-toolbar-template').html()),
                    columns: columns,
                    resizable: true
                },
                enableExport: {
                    entityName: 'CallDetailRecord',
                    title: 'International Summary Records',
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: true
                },
                gridId: 'tblCdrInternationalSummaryKendo',
                showPagerOnTop: false,
                controller: self
            };
            self.cdrInternationalTable.initGrid(gridOptions);
            self.initInternationalTableFilter();
        };
        CallDetailRecord.prototype.initInternationalTableFilter = function () {
            var self = this;
            function split(val) {
                return val.split(/,\s*/);
            }
            function extractLast(term) {
                return split(term).pop();
            }
            var selectedItems = [];
            function filterSelectedCustomers(term) {
                var filteredItems = ko.utils.arrayFilter(selectedItems, function (item) {
                    return term.indexOf(item.label) > -1;
                });
                var mappedData = ko.utils.arrayMap(filteredItems, function (item) {
                    return item.value;
                });
                var customersList = ko.utils.arrayGetDistinctValues(mappedData).sort();
                log.log(customersList);
                self.filterInternationalByCustomer(customersList.join(","));
            }
            $('input[name=filterInternationalCustomer]').bind("keydown", function (event) {
                if (event.keyCode === $.ui.keyCode.TAB &&
                    $(this).autocomplete("instance").menu['active']) {
                    event.preventDefault();
                }
            }).autocomplete({
                source: function (request, response) {
                    tools.ajaxPost({
                        url: "/Customers/findCustomerByName",
                        data: { Name: extractLast(request.term) },
                        success: function (Results) {
                            response($.map(Results.Data, function (item) {
                                return {
                                    label: item.Name,
                                    value: item.Id,
                                    OfficeLocations: item.OfficeLocations
                                };
                            }));
                        }
                    });
                },
                select: function (event, ui) {
                    var terms = split(this.value);
                    // remove the current input
                    terms.pop();
                    // add the selected item
                    terms.push(ui.item.label);
                    selectedItems.push(ui.item);
                    // add placeholder to get the comma-and-space at the end
                    terms.push("");
                    this.value = terms.join(", ");
                    filterSelectedCustomers(this.value);
                    return false;
                },
                focus: function (event, ui) {
                    event.preventDefault();
                },
                open: function (event, ui) {
                    $(this).autocomplete('widget').css('z-index', 1060);
                    $(this).keydown(function (e) {
                        if (e.keyCode === 13) {
                            $(".ui-menu-item:first a").click();
                        }
                    });
                }
            });
            self.filterInternationalByStartDate.subscribe(function () {
                self.cdrInternationalTable.getGridData().dataSource.read();
            });
            self.filterInternationalByEndDate.subscribe(function () {
                self.cdrInternationalTable.getGridData().dataSource.read();
            });
            self.filterInternationalByCustomer.subscribe(function () {
                self.cdrInternationalTable.getGridData().dataSource.read();
            });
            self.filterInternationalByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.cdrInternationalTable.getGridData().dataSource.read();
            });
        };
        CallDetailRecord.prototype.initTollFreeGrid = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            self.cdrTollFreeTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/CallDetailRecord/GetCdrTollFreeSummaryRecords",
                            type: "POST",
                            data: function () {
                                var data = {};
                                data.startDate = dateUtils.toIsoStringDate(self.filterTollFreeByStartDate());
                                data.endDate = dateUtils.toIsoStringDate(self.filterTollFreeByEndDate());
                                if (self.filterTollFreeByCustomer()) {
                                    data.customerIds = self.filterTollFreeByCustomer();
                                }
                                if (self.filterTollFreeByAny()) {
                                    data.filterText = self.filterTollFreeByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                    },
                    pageSize: 10,
                    aggregate: gridStructure.aggregate,
                    serverAggregates: true
                },
                gridOptions: {
                    toolbar: kendo.template($('#cdr-tallfree-toolbar-template').html()),
                    columns: columns,
                    resizable: true
                },
                enableExport: {
                    entityName: 'CallDetailRecord',
                    title: 'Toll Free Summary Records',
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: true
                },
                gridId: 'tblCdrTallFreeSummaryKendo',
                showPagerOnTop: false,
                controller: self
            };
            self.cdrTollFreeTable.initGrid(gridOptions);
            self.initTollFreeTableFilter();
        };
        CallDetailRecord.prototype.initTollFreeTableFilter = function () {
            var self = this;
            function split(val) {
                return val.split(/,\s*/);
            }
            function extractLast(term) {
                return split(term).pop();
            }
            var selectedItems = [];
            function filterSelectedCustomers(term) {
                var filteredItems = ko.utils.arrayFilter(selectedItems, function (item) {
                    return term.indexOf(item.label) > -1;
                });
                var mappedData = ko.utils.arrayMap(filteredItems, function (item) {
                    return item.value;
                });
                var customersList = ko.utils.arrayGetDistinctValues(mappedData).sort();
                log.log(customersList);
                self.filterTollFreeByCustomer(customersList.join(","));
            }
            $('input[name=filterTollFreeCustomer]').bind("keydown", function (event) {
                if (event.keyCode === $.ui.keyCode.TAB &&
                    $(this).autocomplete("instance").menu['active']) {
                    event.preventDefault();
                }
            }).autocomplete({
                source: function (request, response) {
                    tools.ajaxPost({
                        url: "/Customers/findCustomerByName",
                        data: { Name: extractLast(request.term) },
                        success: function (Results) {
                            response($.map(Results.Data, function (item) {
                                return {
                                    label: item.Name,
                                    value: item.Id,
                                    OfficeLocations: item.OfficeLocations
                                };
                            }));
                        }
                    });
                },
                select: function (event, ui) {
                    var terms = split(this.value);
                    // remove the current input
                    terms.pop();
                    // add the selected item
                    terms.push(ui.item.label);
                    selectedItems.push(ui.item);
                    // add placeholder to get the comma-and-space at the end
                    terms.push("");
                    this.value = terms.join(", ");
                    filterSelectedCustomers(this.value);
                    return false;
                },
                focus: function (event, ui) {
                    event.preventDefault();
                },
                open: function (event, ui) {
                    $(this).autocomplete('widget').css('z-index', 1060);
                    $(this).keydown(function (e) {
                        if (e.keyCode === 13) {
                            $(".ui-menu-item:first a").click();
                        }
                    });
                }
            });
            self.filterTollFreeByStartDate.subscribe(function () {
                self.cdrTollFreeTable.getGridData().dataSource.read();
            });
            self.filterTollFreeByEndDate.subscribe(function () {
                self.cdrTollFreeTable.getGridData().dataSource.read();
            });
            self.filterTollFreeByCustomer.subscribe(function () {
                self.cdrTollFreeTable.getGridData().dataSource.read();
            });
            self.filterTollFreeByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.cdrTollFreeTable.getGridData().dataSource.read();
            });
        };
        CallDetailRecord.prototype.initGrid = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            self.cdrTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/CallDetailRecord/GetCallDetailRecords",
                            type: "POST",
                            data: function () {
                                var data = {};
                                data.startDate = dateUtils.toIsoStringDate(self.filterByStartDate());
                                data.endDate = dateUtils.toIsoStringDate(self.filterByEndDate());
                                if (self.filterByProvider()) {
                                    data.provider = self.filterByProvider();
                                }
                                if (self.filterByCallType()) {
                                    data.callType = self.filterByCallType();
                                }
                                if (self.filterByCustomer()) {
                                    data.customerIds = self.filterByCustomer();
                                }
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($('#cdr-toolbar-template').html()),
                    columns: columns,
                    resizable: true
                },
                enableExport: {
                    entityName: 'CallDetailRecord',
                    title: 'Call Detail Records',
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: true,
                },
                gridId: 'tblCdrKendo',
                showPagerOnTop: false,
                controller: self
            };
            self.cdrTable.initGrid(gridOptions);
            self.initTableFilter();
        };
        CallDetailRecord.prototype.initTableFilter = function () {
            var self = this;
            function split(val) {
                return val.split(/,\s*/);
            }
            function extractLast(term) {
                return split(term).pop();
            }
            var selectedItems = [];
            function filterSelectedCustomers(term) {
                var filteredItems = ko.utils.arrayFilter(selectedItems, function (item) {
                    return term.indexOf(item.label) > -1;
                });
                var mappedData = ko.utils.arrayMap(filteredItems, function (item) {
                    return item.value;
                });
                var customersList = ko.utils.arrayGetDistinctValues(mappedData).sort();
                log.log(customersList);
                self.filterByCustomer(customersList.join(","));
            }
            $('input[name=filterCustomer]').bind("keydown", function (event) {
                if (event.keyCode === $.ui.keyCode.TAB &&
                    $(this).autocomplete("instance").menu['active']) {
                    event.preventDefault();
                }
            }).autocomplete({
                source: function (request, response) {
                    tools.ajaxPost({
                        url: "/Customers/findCustomerByName",
                        data: { Name: extractLast(request.term) },
                        success: function (Results) {
                            response($.map(Results.Data, function (item) {
                                return {
                                    label: item.Name,
                                    value: item.Id,
                                    OfficeLocations: item.OfficeLocations
                                };
                            }));
                        }
                    });
                },
                select: function (event, ui) {
                    var terms = split(this.value);
                    // remove the current input
                    terms.pop();
                    // add the selected item
                    terms.push(ui.item.label);
                    selectedItems.push(ui.item);
                    // add placeholder to get the comma-and-space at the end
                    terms.push("");
                    this.value = terms.join(", ");
                    filterSelectedCustomers(this.value);
                    return false;
                },
                focus: function (event, ui) {
                    event.preventDefault();
                },
                open: function (event, ui) {
                    $(this).autocomplete('widget').css('z-index', 1060);
                    $(this).keydown(function (e) {
                        if (e.keyCode === 13) {
                            $(".ui-menu-item:first a").click();
                        }
                    });
                }
            });
            self.filterByStartDate.subscribe(function () {
                self.cdrTable.getGridData().dataSource.read();
            });
            self.filterByEndDate.subscribe(function () {
                self.cdrTable.getGridData().dataSource.read();
            });
            self.filterByCallType.subscribe(function () {
                self.cdrTable.getGridData().dataSource.read();
            });
            self.filterByProvider.subscribe(function () {
                self.cdrTable.getGridData().dataSource.read();
            });
            self.filterByCustomer.subscribe(function () {
                self.cdrTable.getGridData().dataSource.read();
            });
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.cdrTable.getGridData().dataSource.read();
            });
        };
        CallDetailRecord.prototype.initImportRegisterGrid = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            columns.push({
                field: "",
                title: "",
                width: '200px',
                sortable: false,
                template: function (dataItem) {
                    var html = '';
                    if (stringUtils.contains(dataItem.LastMessage, "Completed") || stringUtils.contains(dataItem.LastMessage, "Error")) {
                        html += '<a class="btn btn-sm btn-info btn-reimport" href="#"><i class="fa fa-refresh "></i>&nbsp;Reimport</a>';
                    }
                    html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i>&nbsp;Delete</button>';
                    return html;
                }
            });
            self.cdrImportRegisterTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/CallDetailRecord/GetCdrImportRegisterRecords",
                            type: "POST",
                            data: function () {
                                var data = {};
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model
                    },
                    sort: { field: "ImportDate", dir: "desc" },
                    pageSize: 10
                },
                gridOptions: {
                    columns: columns,
                    dataBound: function (e) {
                        var data = e.sender.dataItems();
                        ko.utils.arrayForEach(data, function (item) {
                            if (stringUtils.contains(item.LastMessage, "Processing") || stringUtils.contains(item.LastMessage, "Added to queue") || stringUtils.contains(item.LastMessage, "Uploaded")) {
                                if (self.autoRefreshProcess) {
                                    clearTimeout(self.autoRefreshProcess);
                                }
                                log.log('start auto refresh');
                                self.autoRefreshProcess = setTimeout(function () {
                                    self.cdrImportRegisterTable.refresh();
                                }, 5000);
                            }
                        });
                    },
                    sortable: true,
                    resizable: true,
                    reorderable: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row menu",
                        extra: false
                    }
                },
                gridId: 'tblCdrImportKendo',
                controller: self
            };
            self.cdrImportRegisterTable.initGrid(gridOptions);
            $('#tblCdrImportKendo').on('click', '.btn-remove', function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.deleteImportedDataConfirm(data.Id);
                event.preventDefault();
            }).on('click', '.btn-reimport', function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.reimportImportedDataConfirm(data.Id);
                event.preventDefault();
            });
        };
        CallDetailRecord.prototype.deleteImportedDataConfirm = function (importId) {
            var self = this;
            tools.confirmModal({
                title: 'Delete Imported data',
                text: 'Are you sure you want to delete Imported data?',
                buttonTitle: 'Delete',
                type: 'danger',
                modalOptions: {},
            }, function (modal) {
                $(modal).modal('hide');
                var data = {
                    id: importId
                };
                data['__RequestVerificationToken'] = $('#antiForgery input[name="__RequestVerificationToken"]').val();
                tools.ajaxPost({
                    url: "/CallDetailRecord/DeleteImportedDataConfirmed",
                    data: data
                }).done(function (result) {
                    if (result.Success) {
                        tools.success('Imported data deleted successfully');
                        self.cdrImportRegisterTable.refresh();
                    }
                    else {
                        tools.error(result.Error);
                    }
                });
            });
        };
        CallDetailRecord.prototype.reimportImportedDataConfirm = function (importId) {
            var self = this;
            tools.confirmModal({
                title: 'Reimport Cdr Records',
                text: 'Are you sure you want to Reimport Cdr Records?',
                buttonTitle: 'Reimport',
                type: 'info',
                modalOptions: {},
            }, function (modal) {
                $(modal).modal('hide');
                var data = {
                    id: importId
                };
                data['__RequestVerificationToken'] = $('#antiForgery input[name="__RequestVerificationToken"]').val();
                tools.ajaxPost({
                    url: "/CallDetailRecord/ReimportImportedDataConfirmed",
                    data: data
                }).done(function (result) {
                    if (result.Success) {
                        tools.success('Reimport started successfully');
                        self.cdrImportRegisterTable.refresh();
                    }
                    else {
                        tools.error(result.Error);
                    }
                });
            });
        };
        CallDetailRecord.prototype.importCdr = function () {
            var self = this;
            self.cdrActions.openImportWindow(function () {
                self.cdrTable.refresh();
                if (self.autoRefreshProcess) {
                    clearTimeout(self.autoRefreshProcess);
                }
                log.log('start auto refresh');
                self.autoRefreshProcess = setTimeout(function () {
                    self.cdrImportRegisterTable.refresh();
                }, 1000);
            });
        };
        CallDetailRecord.prototype.clearFilter = function () {
            var self = this;
            self.filterByStartDate(dateUtils.firstDayOfMonth());
            self.filterByEndDate(dateUtils.lastDayOfMonth());
            self.filterByAny(null);
            self.filterByCallType(null);
            self.filterByProvider(null);
            self.filterByCustomer(null);
            self.filterByCustomerName(null);
        };
        CallDetailRecord.prototype.clearTollFreeFilter = function () {
            var self = this;
            self.filterTollFreeByStartDate(dateUtils.firstDayOfMonth());
            self.filterTollFreeByEndDate(dateUtils.lastDayOfMonth());
            self.filterTollFreeByAny(null);
            self.filterTollFreeByCustomer(null);
            self.filterTollFreeByCustomerName(null);
        };
        CallDetailRecord.prototype.clearInternationalFilter = function () {
            var self = this;
            self.filterInternationalByStartDate(dateUtils.firstDayOfMonth());
            self.filterInternationalByEndDate(dateUtils.lastDayOfMonth());
            self.filterInternationalByAny(null);
            self.filterInternationalByCustomer(null);
            self.filterInternationalByCustomerName(null);
        };
        CallDetailRecord.prototype.exportTo = function () {
            var self = this;
            if (self.canExport) {
                self.cdrTable.exportTo();
            }
        };
        CallDetailRecord.prototype.exportToTollFree = function () {
            var self = this;
            if (self.canExport) {
                self.cdrTollFreeTable.exportTo();
            }
        };
        CallDetailRecord.prototype.exportToInternational = function () {
            var self = this;
            if (self.canExport) {
                self.cdrInternationalTable.exportTo();
            }
        };
        CallDetailRecord.prototype.showLogs = function () {
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("CdrImportRegister");
                dataLogs.open("Cdr Import Register Log");
                event.preventDefault();
            }
        };
        return CallDetailRecord;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith('/CallDetailRecord/Index')) {
            log.log('Initialize CDR list');
            $(function () {
                (new CallDetailRecord()).init();
            });
        }
    }, 0);
    return CallDetailRecord;
});
//# sourceMappingURL=callDetailRecords.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/callDetailRecord/callDetailRecords.js
// module id = 248
// module chunks = 2